var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"border-bottom px-0",class:_vm.$style.titleContainer},[_c('div',{staticClass:"m-0",class:_vm.$style.title},[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }